var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import { observer } from 'mobx-react';

import { DateTimePicker } from 'react-widgets';
import 'react-widgets/styles.css';

export var DatePicker = observer(function (props) {
  return React.createElement(DateTimePicker, _extends({ defaultValue: new Date() }, props));
});